interface VersionInfo {
  buildTag: string;
  buildDate: string;
  commitHash: string;
}

export const versionInfo: VersionInfo = {
  buildTag: "release/2.5.0",
  buildDate: "2025-04-25T17:56:53.",
  commitHash: "f372a365",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).APP_VERSION_INFO = versionInfo;
export default versionInfo;
